import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';

const propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  style: PropTypes.object,
  className: PropTypes.string
};

const defaultProps = {
  style: {},
  className: ''
};

const NavBrand = (props) => {
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let navbar;
  if (theme && theme.navbar) {
    navbar = theme.navbar;
  } else {
    navbar = context.theme.navbar;
  }
  const styles = StyleSheet.create({
    navBrand: {
      display: 'flex',
      cursor: 'pointer',
      marginLeft: navbar.navbarBrandMarginLeft,
      marginRight: navbar.navbarBrandMarginRight
    },
    navBrandSignedIn: {
      '@media (max-width: 479px)': {
        display: 'none'
      }
    }
  });

  return (
    <div
      className={`qtxui-nav-brand ${props.className} ${css(styles.navBrand, props.isSignedIn && styles.navBrandSignedIn)}`}
      onClick={props.onClick}
      style={{ ...props.style }}
    >
      {props.children}
    </div>
  );
};

NavBrand.propTypes = propTypes;
NavBrand.defaultProps = defaultProps;

export { NavBrand };
